import React from 'react';
import { BrainIcon, HeartIcon, SparklesIcon } from 'lucide-react';
import { motion } from 'framer-motion';
export function TrustBar() {
  const items = [{
    icon: BrainIcon,
    text: 'Neurociencia'
  }, {
    icon: HeartIcon,
    text: 'Mindfulness'
  }, {
    icon: SparklesIcon,
    text: 'Sabiduría Práctica'
  }];
  return <section className="bg-[#0A192F] border-y border-[#1D3461] py-8" data-id="element-120">
      <div className="max-w-5xl mx-auto px-6" data-id="element-121">
        <div className="flex flex-wrap justify-center items-center gap-12 md:gap-24 opacity-80" data-id="element-122">
          {items.map((item, index) => <motion.div key={index} className="flex items-center gap-3" initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2,
          duration: 0.6
        }} data-id="element-123">
              <item.icon className="w-6 h-6 text-[#D4AF37]" strokeWidth={1.5} data-id="element-124" />
              <span className="text-[#A8B2D1] font-['Inter'] text-sm tracking-widest uppercase" data-id="element-125">
                {item.text}
              </span>
            </motion.div>)}
        </div>
      </div>
    </section>;
}